import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const TermsAndConditionsWrapper = styled(Box)(({ theme }) => ({
  paddingBottom: '60px',
  [theme.breakpoints.down('md')]: {
    paddingBottom: '40px',
  },
  [theme.breakpoints.down('sm')]: {
    paddingBottom: '30px',
  },
}));
